import { spacing } from 'ext-ui/style/spacing'
import React from 'react'
import ReceiptAgentAvatar from 'src/components/ReceiptAgentAvatar/ReceiptAgentAvatar'
import styled from 'styled-components'

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

const Message = styled.div`
  min-width: 0;
`

interface PolicyStatusTooltipContentProps {
  children: React.ReactNode
}

export default function PolicyStatusTooltipContent({
  children,
}: PolicyStatusTooltipContentProps): React.ReactElement {
  return (
    <Content>
      <ReceiptAgentAvatar />
      <Message>{children}</Message>
    </Content>
  )
}
